module.exports = __webpack_public_path__ + "assets/icon-3-09c2784f.png";